import { ValidateJSModel, LocationModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModel from '../location';

interface LocationUSAddressModel {
  street: LocationModel['street']
  street2: LocationModel['street2']
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
  zipcode: LocationModel['zipcode']
}

const locationUSAddressModelValidator: ValidateJSModel<LocationUSAddressModel> = {
  street: locationModel.street as ValidateJSModelAttribute<LocationUSAddressModel, 'street'>,
  street2: locationModel.street2 as ValidateJSModelAttribute<LocationUSAddressModel, 'street2'>,
  city: locationModel.city as ValidateJSModelAttribute<LocationUSAddressModel, 'city'>,
  state: locationModel.state as ValidateJSModelAttribute<LocationUSAddressModel, 'state'>,
  zipcode: locationModel.zipcode as ValidateJSModelAttribute<LocationUSAddressModel, 'zipcode'>,
  country: {
    presence: true,
    inclusion: ['United States'],
  },
};

export default locationUSAddressModelValidator;
